export default "/smashed-expander-eth.133dcd88c6e764ab179b7a559df4009f.svg";